export default __webpack_public_path__ + "static/media/checkgreen.861324da.png";